import { render, staticRenderFns } from "./PersonTooltip.vue?vue&type=template&id=35fd618f&scoped=true"
import script from "./PersonTooltip.vue?vue&type=script&lang=js"
export * from "./PersonTooltip.vue?vue&type=script&lang=js"
import style0 from "./PersonTooltip.vue?vue&type=style&index=0&id=35fd618f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd618f",
  null
  
)

export default component.exports